import { OnboardingFilters, OnboardingManagementView, defaultOnboardingFilters } from './advisor-onboarding.model';

export interface IOnboardingState {
  onboardings: OnboardingManagementView[];
  filters: OnboardingFilters;
  totalCount: number;
  currentPage: number;
  isLoading: boolean;
  error: string | null;
}

export const initialOnboardingState: IOnboardingState = {
  onboardings: [],
  filters: { ...defaultOnboardingFilters },
  totalCount: 0,
  currentPage: 1,
  isLoading: false,
  error: null,
};
